import RichText from "@/components/RichText";
import { CONTAINER } from "../tokens";

// Technologies : texte de réassurance à gauche, pastilles à droite.
export default function TechStackSection({ props = {}, blocks = [] }) {
  const pills = (blocks || []).filter((b) => b.type === "tech_pill" && b.enabled !== false);

  return (
    <section id="techno" className={`${CONTAINER} py-[92px] scroll-mt-24`}>
      <div className="grid md:grid-cols-2 gap-10 items-start">
        <div>
          <RichText
            as="h2"
            className="block font-display font-semibold text-[clamp(29px,3.5vw,43px)] leading-[1.06] tracking-[-0.03em] text-ink [text-wrap:pretty]"
            html={props.heading}
          />
          <RichText
            as="p"
            preserveParagraphs
            className="mt-5 text-[16.5px] leading-[1.6] text-ink/[0.6] max-w-[440px]"
            html={props.body}
          />
        </div>
        <div className="flex flex-wrap gap-[9px]">
          {pills.map((b) => (
            <span
              key={b.id}
              data-block-key={b.id}
              className="font-display border-control border-ink/[0.16] rounded-full py-[9px] px-4 text-[14px] text-ink/80"
            >
              {b.props?.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
